export default __webpack_public_path__ + "static/noah-regular-a666820b03e3ba7ab065e03763fcb399.otf";